export const QUERY_PARAMS = {
  SOLUTION: 'solution',
  CLIENT_ID: 'client_id',
  RESPONSE_TYPE: 'response_type',
  REDIRECT_URI: 'redirect_uri',

  COMPANY_SYSTEM_NAME: 'company_system_name',

  INVITATION_TOKEN: 'invitation_token',
  RESET_PASSWORD_TOKEN: 'reset_password_token',

  LANG: 'lang',
  STATE: 'state',
  FORCE_LOGIN: 'force_login',

  CODE_CHALLENGE: 'code_challenge',
  CODE_CHALLENGE_METHOD: 'code_challenge_method',

  SSO_ERROR: 'error',
  SSO_RETURN_URL: 'return_url',
};
